import React from 'react';
import { ConfirmationModal, Typography } from 'seagull';
import styles from "./GenerateLinkModal.module.scss";
import pluralize from 'pluralize';
export const GenerateLinkModal = _ref => {
  let {
    recipientsCount,
    dismissModal
  } = _ref;
  return /*#__PURE__*/React.createElement(ConfirmationModal, {
    "data-testId": 'generate-link-modal',
    title: "Share by link",
    width: "800px",
    content: /*#__PURE__*/React.createElement("div", {
      className: styles.generateModalContent
    }, /*#__PURE__*/React.createElement(Typography, null, "Generating a shareable link for a proposal means the proposal will not be sent via email through Anchor."), /*#__PURE__*/React.createElement(Typography, null, "Please note the following:"), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", {
      className: styles.listItem
    }, /*#__PURE__*/React.createElement(Typography, null, "The proposal's status will change to \"Sent.\"")), /*#__PURE__*/React.createElement("li", {
      className: styles.listItem
    }, /*#__PURE__*/React.createElement(Typography, null, "Your client will receive reminders as needed, according to your notification settings.")), /*#__PURE__*/React.createElement("li", {
      className: styles.listItem
    }, /*#__PURE__*/React.createElement(Typography, null, "Each link is unique to its recipient, so ensure it is shared with the correct person.")))),
    onCloseButtonClick: () => dismissModal(false),
    secondaryButtonLabel: "Cancel",
    secondaryButtonTestid: "generate-link-modal-cancel",
    onSecondaryButtonClick: () => dismissModal(false),
    primaryButtonLabel: "Generate ".concat(pluralize('link', recipientsCount)),
    primaryButtonTestid: "generate-link-modal-generate",
    onPrimaryButtonClick: () => {
      dismissModal(true);
    }
  });
};